import { Link, useLocation } from "react-router-dom";

export const Header = () => {
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-[#F9F6F0]/85 backdrop-blur-md border-b border-[#E6DFD3]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-5 sm:py-6 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-home-link"
          className="font-serif text-xl sm:text-2xl tracking-tight text-[#2D231E] hover:text-[#8B7355] transition-colors"
        >
          WorkSpaces
        </Link>
        {!onHome && (
          <Link
            to="/"
            data-testid="header-back-link"
            className="font-sans text-xs sm:text-sm tracking-[0.2em] uppercase text-[#5D4037] hover:text-[#2D231E] transition-colors"
          >
            ← All Locations
          </Link>
        )}
      </div>
    </header>
  );
};
